module.exports = __webpack_public_path__ + "static/img/class_13.3f306c2c.jpg";